module.exports = __webpack_public_path__ + "img/ad4.661063f7.png";